import React from 'react';
import { Filters } from '@apps/accommodations/hooks/useListingFilters';
import { useTranslation } from '@shared/core';
import { Flex, TextV2, ButtonV2, Box } from '@withjoy/joykit';
import { HotelProduct } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';

interface ExploreMoreHotelsProps {
  filter: Filters;
  handlePickedByCoupleToggle: () => void;
}

export const ExploreMoreHotels = ({ filter, handlePickedByCoupleToggle }: ExploreMoreHotelsProps) => {
  const { t } = useTranslation('accommodationsConsole');
  const exploreMoreTrans = t('listingsPanel', 'exploreMore');

  if (!filter.pickedByCouple) {
    return null;
  }

  return (
    <Flex width="100%" justifyContent={'center'}>
      <Box display="flex" flexDirection="column" alignItems="center" rowGap={4} maxWidth={pxToRem(340)}>
        <HotelProduct size={48} />
        <TextV2 typographyVariant="hed5" textAlign={'center'}>
          {exploreMoreTrans.title()}
        </TextV2>
        <TextV2 typographyVariant="body1" textAlign={'center'}>
          {exploreMoreTrans.subTitle({ count: 500 })}
        </TextV2>
        <ButtonV2 variant="outline" marginTop={4} shape="rounded" color={'mono14'} borderColor={'mono14'} onClick={handlePickedByCoupleToggle}>
          {exploreMoreTrans.buttonText({ count: 500 })}
        </ButtonV2>
      </Box>
    </Flex>
  );
};
